<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 text-xs-center>
        <img
          v-if="picture.filename !== null && picture.filename.length > 0"
          :src="
            this.$store.getters.getApiUrl +
              '/uploads/picture/' +
              picture.filename
          "
          :alt="picture.title"
          class=""
          v-bind:style="{ 'max-width': '100%', height: 'auto' }"
        />
      </v-flex>

      <v-flex xs12 text-xs-center>
        <!-- Main video -->
        <video
          v-if="video.filename !== null && video.filename.length > 0"
          height="300"
          controls
          preload="metadata"
          webkit-playsinline="true"
          playsinline="true"
          :poster="
            this.$store.getters.getApiUrl +
              '/assets/admin/img/new_lingron_250.png'
          "
        >
          <source
            :src="
              this.$store.getters.getApiUrl + '/uploads/video/' + video.filename
            "
            type="video/mp4"
          />
          <source
            :src="
              this.$store.getters.getApiUrl + '/uploads/video/' + video.filename
            "
            type="video/ogg"
          />
          <source
            :src="
              this.$store.getters.getApiUrl + '/uploads/video/' + video.filename
            "
            type="video/webm"
          />
          Your browser does not support the video tag.
        </video>

        <!-- Youtube video -->
        <div v-if="youtube.url !== null && youtube.url.length > 0">
          <LazyYoutubeVideo
            :src="'https://www.youtube.com/embed/' + youtube.url"
          />
        </div>
      </v-flex>

      <!-- <v-flex xs12 d-flex text-xs-center mt-4>
          <h2>
            Ebben a leckében a következőket tanulhatod meg:
          </h2>
      </v-flex> -->

      <v-flex offset-xs1 xs10 offset-md2 md8 d-flex text-xs-center>
        <p>
          {{ description }}
        </p>
      </v-flex>

      <v-flex xs12 d-flex text-xs-center>
        <v-layout row wrap>
          <v-flex
            xs12
            md10
            offset-md1
            v-for="(sentence, index) in sentences"
            v-bind:key="index"
            class="summarySentences"
          >
            <transition name="fadeSlow">
              <!-- <v-card v-bind:color="sentence.color" dark v-show="sentence.show"> -->
              <v-card color="#d1d1d1" class="p-3">
                {{ sentence.sentence }}
              </v-card>
            </transition>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 offset-md1 md10 text-xs-left>
        <v-layout row wrap v-for="(item, index) in conversations" :key="index">
          <v-flex :class="renderFlex(index)" mt-1>
            <v-layout fill-height>
              <v-flex :class="renderAvatar(index)" style="position:relative;">
                <v-spacer></v-spacer>
                <v-avatar style="position:absolute; bottom: 0 !important;">
                  <img
                    v-if="item.picture !== null"
                    :src="apiUrl + '/uploads/picture/' + item.picture.filename"
                    :alt="item.name"
                  />
                </v-avatar>
              </v-flex>

              <v-flex :class="renderCardFlex(index)">
                <div :class="renderName(index)" class="text-muted">
                  {{ item.name }}
                </div>
                <v-card :class="renderCard(index)" dark>
                  <div class="conversationMain pb-1">
                    {{ item.content_main }}
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-spacer></v-spacer>

      <v-flex xs12 class="mt-2 align-self-center text-center">
        <v-divider></v-divider>

        <v-layout row wrap class="bgBlue">
          <v-flex xs12>
            <v-btn
              large
              dark
              flat
              @click="
                $router.push({
                  name: 'freeQuestion',
                  params: { lessonId: lessonId }
                })
              "
            >
              Tovább
              <v-icon right dark>keyboard_arrow_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-dialog v-model="showTipp" width="600">
        <v-card>
          <v-card-title class="headline mainBlue dark text-light" primary-title>
            Segítség
            <v-spacer></v-spacer>
            <v-btn color="error" fab small @click="showTipp = false">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="showTipp = false">
            <img
              :src="require('@/assets/img/middle_step1.png')"
              alt="help"
              class="img-responsive"
            />
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="error" dark @click="showTipp = false">
                  Bezár
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { setTimeout } from "timers";
import LazyYoutubeVideo from "vue-lazy-youtube-video";

export default {
  components: {
    LazyYoutubeVideo
  },
  data: function() {
    return {
      // lessonId: this.$route.params.lessonId,
      lessonId: this.$store.getters.currentLessonId,
      apiUrl: this.$store.getters.getApiUrl,
      sentences: "",
      conversations: "",
      picture: {
        filename: "",
        title: ""
      },
      video: {
        filename: "",
        title: ""
      },
      youtube: {
        url: "",
        show: true
      },
      description: "",
      showTipp: false
    };
  },
  methods: {
    getLessonData() {
      axios
        .post(
          this.$store.getters.getApiUrl + "/api/lesson/free/prologue/load",
          {
            // token: this.$store.getters.getToken,
            lessonId: this.$data.lessonId
          }
        )
        .then(response => {
          // console.log("prologue - resp: ", response.data);
          this.$data.sentences = response.data.sentences;
          this.$data.conversations = response.data.conversations;
          this.$data.picture.filename = response.data.picture.filename;
          this.$data.picture.title = response.data.picture.title;
          this.$data.description = response.data.description;

          if (response.data.video !== null) {
            this.$data.video.filename = response.data.video.filename;
            this.$data.video.title = response.data.video.title;
          }

          if (response.data.youtubeUrl !== null) {
            this.$data.youtube.url = response.data.youtubeUrl;
            this.$data.youtube.show = true;
          }

          // if( this.$data.lessonId === 169 )
          // {
          //     this.$data.showTipp = true;
          // }
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log("question- error: ", error);
          }
        });
    },
    renderFlex(index) {
      let newIndex = index;

      if (newIndex % 2 === 0) {
        return "xs12 sm8";
      } else {
        return "xs12 offset-sm4 sm8";
      }
    },
    renderCard(index) {
      if (index % 2 === 0) {
        return "pilled mainGrey messageLeft text-black";
      } else {
        return "pilled mainLightBlue messageRight";
      }
    },
    renderCardFlex(index) {
      if (index % 2 === 0) {
        return "xs10 order-xs2";
      } else {
        return "xs10 order-xs1";
      }
    },
    renderAvatar(index) {
      if (index % 2 === 0) {
        return "xs2 order-xs1 text-xs-right mr-5 pr-3";
      } else {
        return "xs2 order-xs2 ml-2";
      }
    },
    renderName(index) {
      if (index % 2 === 0) {
        return "text-xs-left";
      } else {
        return "text-xs-right";
      }
    }
  },
  created: function() {
    this.getLessonData();
  }
};
</script>
